module.exports = __webpack_public_path__ + "img/system25-mini.e45cdb3a.png";